import tldToCountryCode from '@hydra/utils/tldToCountryCode';

export default searchEngineCode => {
  const [country, language] = searchEngineCode.split('_');
  const countryFlag = tldToCountryCode(country);
  const countryKey = `country_name_${country.toUpperCase()}`;
  const languageKey = language ? `lang_${language}` : '';

  return Object.assign({},
    {
      country,
      language,
      countryFlag,
      countryKey,
      languageKey
    }
  );
};
